module.exports = __webpack_public_path__ + "img/logo.ff052206.svg";